'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { getValidQuote } = require('./shippingHelpers.es');
const { DOMESTIC, LOCAL } = require('./ShippingConstants.json');

function QuotePrimary({ quotes, currency }) {
    const { output: outputDomestic } = getValidQuote({
        quotes: quotes.domestic,
        regionType: DOMESTIC,
        currency,
    });

    const { output: outputLocal } = getValidQuote({
        quotes: quotes.local,
        regionType: LOCAL,
        isLocalPrimary: true,
        currency,
    });

    if (outputDomestic || outputLocal) {
        return <div data-tn="shipping-primary">{outputDomestic || outputLocal}</div>;
    }

    return <div data-tn="shipping-primary">Global Shipping Available</div>;
}

QuotePrimary.propTypes = {
    quotes: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
};

module.exports = QuotePrimary;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/QuotePrimary.jsx